/**
 * Self-contained build-time feature flag for the Brand Palette Wizard
 * (deck `tabs/brand-palette-wizard.html`, concept row 37).
 *
 * WHY ITS OWN FILE (mirrors LinkedWheels/featureFlag.js, ShareVideoModal/
 * featureFlag.js, gradientBuilder/featureFlag.js): kept local so it can be
 * reviewed/merged independently of the parallel Hail-Mary branches that also
 * touch src/constants. Defaults OFF; flipped per environment via a REACT_APP_*
 * build var.
 *
 * When OFF (default), the Color Library renders byte-identical to today — no
 * "Your palettes · Custom built" section header, no "New palette" entry card,
 * and the wizard modal is never mounted (no extra network call). When ON, the
 * Color Library's Saved tab gains the custom-built section + a "New palette"
 * card that opens the manual hex wizard (deck screen 01), which saves through
 * the SAME existing savePalette API used by the rest of the palette system.
 *
 * At merge this can be folded into src/constants/featureFlags.js.
 */
const truthy = (v) => v === "true" || v === "1" || v === true;

export const BRAND_PALETTE_WIZARD_ENABLED = truthy(
  process.env.REACT_APP_BRAND_PALETTE_WIZARD
);
